import { Box, CircularProgress, Container } from '@mui/material';
import { useState, useEffect } from 'react';
import { useDuesSponsoredOrgContext } from '../../global/hooks/useDuesSponsoredOrgContext';
import { useIlpContext } from '../hooks/useIlpContext';
import { useLearnerContext } from '../hooks/useLearnerContext';
import { IPerson } from '../types/interfaces/IPerson';
import { ILearningPlan } from '../types/interfaces/ILearningPlan';
import { IIndividualLearningPlan } from '../types/interfaces/IIndividualLearningPlan';
import ProgramBlock from './ProgramBlock';
import AdvisorList from './AdvisorList';
import LearningPlanAction from './LearningPlanAction';
import LearningPlanList from './LearningPlanList';
import AssessmentView from './AssessmentView';

//This component is responsible for rendering the ilp content.
export default function LearnerLandingView() {
  const { selectedOrganization } = useDuesSponsoredOrgContext();
 const { loadingIlpCtx, setExpandAll, setAreChildrenLoading } = useIlpContext();
  const { individualLearningPlans, individualLearningPlan, setIlps, loadingLearnerCtx, deletePlan } = useLearnerContext();
  const [ilp, setIlp] = useState<IIndividualLearningPlan | null>(null);
  const [topLoadingLearner, setTopLoadingLearner] = useState(loadingIlpCtx || loadingLearnerCtx);

  const advisors: IPerson[] | any = individualLearningPlan?.AvailableReviewers;
    const learningPlans: ILearningPlan[] | any = individualLearningPlans?.flatMap(plan => plan.LearningPlan);
    const RESIDENT_ROLE = process.env.REACT_APP_NFROLE_RESIDENT;

  useEffect(() => {
    if (!loadingIlpCtx && !loadingLearnerCtx) {
        setTopLoadingLearner(false);
        setAreChildrenLoading(false);
    }
  }, [loadingIlpCtx, loadingLearnerCtx]);

  //Function to handle an ilp selection.
  const handleSelect = (selectedIlp: IIndividualLearningPlan) => {
    setIlp(selectedIlp);
  };

  //Function to handle canceling.
  const handleCancel = () => {
      setIlp(null);
      setExpandAll(false);
  };

  //Function to handle an ilp saving.
  const handleSave = (savedIlp: IIndividualLearningPlan | null) => {
    setIlp(null);
    setIlps(savedIlp);
  };

  //Function to handle an ilp deletion.
  const handleDelete = (planKey: string) => {
    setIlp(null);
    deletePlan(planKey);
    };

    //Function to handleprint view.
    const handlePrint = (printIlp: IIndividualLearningPlan | null) => {
        if (printIlp?.LearnerInfo.Role === RESIDENT_ROLE) {
            setExpandAll(true);
        }
    };

    return (
    <Container>
        {topLoadingLearner && <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: 2 }}>
             <CircularProgress />
        </Box>}
        { ilp ? ( <AssessmentView plan={ilp} onSave={handleSave} onCancel={handleCancel} onPrint={handlePrint} /> ) : (
          <>
            {selectedOrganization && <ProgramBlock />}
            {advisors?.length > 0 && <AdvisorList />}
            {learningPlans?.length > 0 && <LearningPlanList onSelect={handleSelect} onDelete={handleDelete} />}
            {<LearningPlanAction onCreate={handleSelect} />}
          </>
        )
      }
            </Container>
  );
}